<template>
  <section id="innovation" class="position-relative">
    <b-container>
      <h5 class="text-white">Innovation</h5>
      <h2 class="text-white">Innovating for growth</h2>
      <p class="text-white medium hidden-xs show-lg">
        Innovation at Ahlstrom-Munksjö is vital for securing both growth and competitiveness <br>
        through improving existing products, designing new ones and exploring emerging technologies <br>
        to understand how they can deliver the products of the future.
      </p>
      <div class="btn-container">
        <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.innovation, 24)"
	        	class="btn btn-black-trans"
		        target="_blank">
		      Learn more
		    </a>
      </div>
    </b-container>
  </section>
</template>

<script>
import full from '../assets/pdf/full-report.pdf';
import innovation from '../assets/pdf/innovation.pdf';

export default {
  name: 'Innovation',
  data() {
    return {
      pdfLinks: {
        'full': full,
        'innovation': innovation
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/sections/Innovation.vue